import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Button, {ButtonColors, ButtonSizes, ButtonTypes} from "../../Button/Button";
import {ReactComponent as CloseIcon} from "../../../assets/icons/x.svg";
import {validate} from "../../../utils/validation";
import {inputValidations} from "../../../utils/validation/configurations";
import {askForConfirmation} from "../../../utils";
import {setLoading} from "../../../actions";
import {createTable, getTables} from "../../../actions/tables";
import {connect} from "react-redux";
import Input, {InputStyles} from "../../Input/Input";

class CreateTableSidebar extends Component {

    state = {
        showValidation: false,
        table: {
            name: ""
        }
    }

    componentDidMount() {
        //
    }

    createTable = async() => {
        const {table} = this.state;
        const {t} = this.props;

        if(validate(inputValidations.tableNameInput, table.name)) {
            this.setState({showValidation: true});
            return;
        }

        if (!await askForConfirmation(t("Do you want to continue?"))) {
            return;
        }

        this.props.setLoading(true);
        this.props.createTable(table).then(res => {
            this.props.getTables();
            this.props.onCloseButtonClick();
            this.props.setLoading(false);
        })
    }

    render() {
        const {t} = this.props;
        const {table, showValidation} = this.state;
        return (
            <div>
                <div className="d-flex justify-content-between mb-16">
                    <h2>{t("Create Table")}</h2>
                    <div className="d-flex">
                        <Button
                            type={ButtonTypes.Icon}
                            onClick={this.props.onCloseButtonClick}>
                            <CloseIcon/>
                        </Button>
                    </div>
                </div>
                <Input
                    label={t("Table name")}
                    id="tableNameInput"
                    name="tableNameInput"
                    value={table.name}
                    style={InputStyles.Material}
                    validations={[inputValidations.tableNameInput, showValidation]}
                    onChange={(e) => this.setState({table: {...table, name: e.target.value}})}/>
                <Button
                    className="mt-24"
                    size={ButtonSizes.Full}
                    color={ButtonColors.Green}
                    type={ButtonTypes.Filled}
                    onClick={() => this.createTable()}>
                    {t("Create Table")}
                </Button>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    setLoading: (data) => dispatch(setLoading(data)),
    getTables: data => dispatch(getTables()),
    createTable: data => dispatch(createTable(data))
});
const connector = connect(null, mapDispatchToProps);
export default connector(withTranslation()(CreateTableSidebar));

